<div
  [class.card--bordered]="border"
  [class.card--danger]="type === 'danger'"
  [class.card--info]="type === 'info'"
  [class.card--success]="type === 'success'"
  [class.card--warning]="type === 'warning'"
  [class.shadow-sm]="shadow"
  [trackImpressionInfo]="rendering"
  [trackImpressionName]="trackImpressionName"
  [wlAutomationId]="automationId"
  class="card card--info overflow-hidden d-flex"
  trackImpression="contentblock-impression"
>
  <div
    [class.align-items-center]="mode === 'single-line'"
    [class.bg-light]="backgroundGrey"
    [class.card-body--danger]="type === 'danger'"
    [class.card-body--info]="type === 'info'"
    [class.card-body--success]="type === 'success'"
    [class.card-body--warning]="type === 'warning'"
    [class.p-1]="mode === 'single-line'"
    class="card-body d-flex"
  >
    @if (type === 'info') {
      <fa-icon class="icon icon--info text-primary me-1" icon="circle-info">
      </fa-icon>
    }
    @if (type === 'warning') {
      <fa-icon
        class="icon icon--info text-warning me-1"
        icon="exclamation-circle"
      ></fa-icon>
    }
    @if (type === 'danger') {
      <fa-icon
        class="icon icon--info text-danger me-1"
        icon="exclamation-triangle"
      >
      </fa-icon>
    }
    @if (type === 'success') {
      <fa-icon class="icon icon--info text-success me-1" icon="check-circle">
      </fa-icon>
    }

    <div class="info-card__content">
      @if (title?.value || titleTranslationKey) {
        <div [wlAutomationId]="automationId + '-title'">
          @if (title) {
            <p *scText="title" class="info-card__title"></p>
          }
          @if (titleTranslationKey) {
            <p class="info-card__title">
              {{ titleTranslationKey | translate }}
            </p>
          }
        </div>
      }

      @let hasButton = !!buttonLink?.value?.href && !hijackButton;
      @let hasHijackButton = hijackButton && !!buttonText;

      @if (message?.value || messageTranslationKey) {
        @let hasButtonBelow = hasButton || hasHijackButton;
        <div
          [wlAutomationId]="automationId + '-description'"
          [class.mb-2]="hasButtonBelow"
        >
          @if (message) {
            <p
              class="text-small text-start"
              [class.mb-0]="!hasButtonBelow"
              *wlGenericRichText="message"
            ></p>
          }
          @if (messageTranslationKey) {
            <p
              class="text-small text-start"
              [class.mb-0]="!hasButtonBelow"
              [innerHTML]="
                messageTranslationKey | translate: messageTranslationParams
              "
            ></p>
          }
        </div>
      }

      @if (hasButton) {
        <div class="info-card__button">
          <a
            [ngClass]="{
              'btn btn-sm': buttonType !== 'link',
              'btn-primary': buttonType === 'button',
              'btn-outline-primary': buttonType === 'button-outline',
              'card-link': buttonType === 'link',
            }"
            [wlAutomationId]="automationId + '-button-link'"
            trackImpression="button-impression"
            [trackImpressionInfo]="rendering"
            [trackImpressionName]="buttonLink?.value.text"
            wlTrackLink
            [trackLinkInfo]="{
              rendering: rendering,
              field: buttonLink?.value,
              linkurl: buttonLink?.value?.href,
              eventType:
                buttonType === 'button' ? 'button-click' : 'link-click',
            }"
            *wlGenericLink="buttonLink; extras: navigationExtras"
          ></a>
        </div>
      }
      @if (hasHijackButton) {
        <div class="info-card__button">
          <button
            type="button"
            class="btn btn-sm text-start"
            [ngClass]="{
              'btn-primary': buttonType === 'button',
              'btn-outline-primary': buttonType === 'button-outline',
              'btn-link p-0 border-0': buttonType === 'link',
            }"
            [wlAutomationId]="automationId + '-button'"
            trackImpression="button-impression"
            [trackImpressionInfo]="rendering"
            [trackImpressionName]="buttonLink?.value?.text || buttonText"
            wlTrackLink
            [trackLinkInfo]="{
              rendering: rendering,
              field: buttonLink?.value?.text || buttonText,
              linkurl: buttonLink?.value?.href,
              eventType: buttonType === 'link' ? 'link-click' : 'button-click',
            }"
            (click)="buttonClick.emit($event)"
          >
            {{ buttonText }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
